@if (!loaderMode) {
  <div class="background"></div>
}
<div class="loader">
  <div class="loaderContent">

    @if (error == '') {

      <div class="satelite" [ngClass]="{'floating': loaderMode}"></div>
      @if (answer != '') {
        <p class="loaderInfo">{{answer | translate}}</p>
      }

    } @else{

      <div class="error-container">

        <div class="error">
          <div class="error-image"></div>

          <div class="error-message">

            <h2>{{ 'MODAL.ERROR_TITLE' | translate}}</h2>

            <p>{{error}}</p>

          </div>

        </div>
      </div>
    }
  </div>
</div>
